export default __webpack_public_path__ + "assets/upload_logo_icon.bc8da8.png";